import { RoomPassengers } from "shared/types/hotels";

export const calculateTotalTravelers = (
  currentRooms: RoomPassengers[],
  hotelRoomCbtAssignments?: {
    [roomIndex: number]: { [assignmentIdx: number]: string } | string[];
  }
): number => {
  if (!currentRooms || currentRooms.length === 0) {
    return 0;
  }

  return currentRooms.reduce((total, room, roomIndex) => {
    const adults = (room.ADT as number) || 0;
    const children = (room.CHD as number) || 0;
    const guests = (room.guests as number) || 0;

    const roomAssignments = hotelRoomCbtAssignments?.[roomIndex];
    let cbtTravelers = 0;

    if (roomAssignments) {
      if (Array.isArray(roomAssignments)) {
        cbtTravelers = roomAssignments.length;
      } else {
        cbtTravelers = Object.values(roomAssignments).length;
      }
    }

    return total + adults + children + guests + cbtTravelers;
  }, 0);
};
